import React from 'react';
// Custom
import { getHocDisplayName } from 'utils/Tools';

const withEnterKeyManager = (WrappedComponent, options = {}) => {
  const { withRef = false } = options;

  class WithEnterKeyManager extends React.Component {
    constructor(props) {
      super(props);

      this.handleKeyPress = this.handleKeyPress.bind(this);

      this.isAlive = true;

      this.state = {
        enterPressed: false,
      };
    }

    componentWillUnmount() {
      this.isAlive = false;
    }

    getWrappedInstance() {
      return withRef ? this.wrappedInstance : null;
    }

    // Handlers
    handleKeyPress(e) {
      if (e && e.key === 'Enter') {
        // e.preventDefault();
        this.setState({
          enterPressed: true,
        }, this.doReinit);
      }
    }

    // Private
    doReinit() {
      if (this.isAlive) {
        this.setState({
          enterPressed: false,
        });
      }
    }

    render() {
      const { enterPressed } = this.state;

      return (
        <WrappedComponent
          onKeyPress={this.handleKeyPress}
          enterPressed={enterPressed}
          ref={withRef ? (wi) => { this.wrappedInstance = wi; } : null}
          {...this.props}
        />
      );
    }
  }

  WithEnterKeyManager.displayName = getHocDisplayName('WithEnterKeyManager', WrappedComponent);

  return WithEnterKeyManager;
};

export default withEnterKeyManager;



// WEBPACK FOOTER //
// ./hocs/WithEnterKeyManager.js